
import axios from "axios";
import { store } from "store";
import { OutputBaseProps } from "utils/types/API";
import { NotificationItemProps } from ".";
import { loading, find } from "store/notification";

interface ApiNotificationFindByIdInputProps {
    id: number;
}

type ApiNotificationFindOutputProps = OutputBaseProps<{ item: NotificationItemProps; }, ApiNotificationFindByIdInputProps>

export const apiNotificationFindById = async (data: ApiNotificationFindByIdInputProps) => {
    store.dispatch(loading());
    const res = (await axios.get<ApiNotificationFindOutputProps>(`/api/notification/${data.id}`))
        .data;
    if (res.code === 0 && res.data) {
        store.dispatch(find({ data: res.data.item }));
    }
    return res;
};


interface ApiNotificationFindByCodeInputProps {
    code: string;
}

export const apiNotificationFindByCode = async (data: ApiNotificationFindByCodeInputProps) => {
    store.dispatch(loading());
    const res = (await axios.get<ApiNotificationFindOutputProps>(`/api/notification/code/${data.code}`))
        .data;
    if (res.code === 0 && res.data) {
        store.dispatch(find({ data: res.data.item }));
    }
    return res;
};